<template>
	<div>
		<div v-if="!loading && eventsPromoted.length > 0">
			<table class="table mt-4">
				<tr class="table-head only-desktop">
					<td width="48px"></td>
					<td>Evento</td>
					<td class="text-center">Entradas Vendidas</td>
					<td class="">Estado</td>
				</tr>

				<router-link tag="tr" :to="`/account/events/${item.id}`" v-for="item of eventsPromoted" :key="item.id">
					<td>
						<div
							class="image"
							v-if="item.event && item.event.image"
							:style="`background-image:url(${item.event.image.url})`"
						></div>
					</td>
					<td>
						<div class="tc" v-if="item.event">
							<span class="bolder">{{ item.event.name }} </span>
							<span class="text-secondary">{{ item.event.startAt | moment("dddd DD MMM HH:mm") }}</span>
						</div>
					</td>
					<td class="only-desktop">
						<div class="tc ">
							<span class="text-center">
								{{ item.ticketsSold }}
							</span>
						</div>
					</td>
					<td class="">
						<div class="tc">
							<span class="d-flex justify-content-end">
								<i class="dot mt-1 mr-1" :class="`dot-${item.event.statusClass}`"></i>
								<span class="only-desktop">{{ item.event.statusText }}</span>
							</span>
						</div>
					</td>
				</router-link>
			</table>
		</div>
		<div class="d-flex p-4 align-items-center" v-if="!loading && eventsPromoted.length == 0">
			<div>
				<svg width="144" height="144" viewBox="0 0 144 144" class="icon__svg">
					<g fill="none" fill-rule="evenodd">
						<path
							fill="currentColor"
							fill-opacity=".1"
							d="M111 58.842V56a8 8 0 00-4.472-7.182c5.372 1.07 9.917 2.334 13.243 3.78 30.26 13.152 11.806 16.984-2.996 25.44-1.965 1.123-3.89 2.216-5.775 3.28v-5.31l2.436-9.093A8 8 0 00111 58.842zM79.68 98.246L67.565 95H41a8 8 0 01-8-8v-1.854a8.003 8.003 0 01-2.93-8.475L33 65.738V56a8 8 0 014.543-7.217l.55-2.056c.157-.58.373-1.13.64-1.642C8.126 46.886-11.461 53.92 20.932 67.48c26.011 10.889-38.853 80.493 58.748 30.767zM61.29 44.66c14.383.239 29.046 1.386 40.753 3.34h-28.29l-2.679-.718-2.12.718h-1.68l-1.995-2.27-3.99-1.07z"
						></path>
						<path
							fill="currentColor"
							fill-rule="nonzero"
							d="M55.284 86.275l1.142-4.26 4.172 1.117-1.141 4.262 1.245 1.295 36.03 9.654a3.68 3.68 0 004.508-2.602l8.023-29.944a3.68 3.68 0 00-2.602-4.507l-36.028-9.654-1.73.5-.882 3.294-4.172-1.118.882-3.294-1.248-1.297-16.71-4.478a3.68 3.68 0 00-4.506 2.603l-8.024 29.943a3.68 3.68 0 002.603 4.507l16.709 4.478 1.729-.499zm1.865 4.405l-.62-.705-2.089.705h2.709zm-5.706 0L37.32 86.896V87A3.68 3.68 0 0041 90.68h10.443zm38.432-38.36l16.805 4.503V56a3.68 3.68 0 00-3.68-3.68H89.875zM67.273 48h1.68l2.121-.718 2.679.718H103a8 8 0 018 8v2.842a8 8 0 012.436 8.073L111 76.007V87a8.002 8.002 0 01-4.925 7.388l-.662 2.471a8 8 0 01-9.798 5.657L67.565 95H41a8 8 0 01-8-8v-1.854a8.003 8.003 0 01-2.93-8.475L33 65.738V56a8 8 0 014.543-7.217l.55-2.056a8 8 0 019.799-5.656l17.387 4.658L67.273 48zm-4.636 10.832l4.173 1.118-1.894 7.07-4.173-1.117 1.894-7.07zm-3.106 11.591l4.173 1.118-1.894 7.07-4.173-1.117 1.894-7.07z"
						></path>
					</g>
				</svg>
			</div>
			<div>
				<h5>Aún no estas promocionando ningún evento.</h5>
				<p>Una vez que te inviten a promocionar un event, podrás verlos aquí.</p>
			</div>
		</div>
	</div>
</template>

<script>
import gql from "graphql-tag"

export default {
	name: "PromoteEvents",
	data() {
		return {
			eventsPromoted: [],
			loading: true
		}
	},
	beforeMount() {
		this.load()
	},
	methods: {
		load() {
			return this.$apollo
				.query({
					query: gql`
						query($take: Int, $skip: Int) {
							eventsPromoted(take: $take, skip: $skip) {
								data {
									id
									ticketsSold
									publicLink
									event {
										id
										name
										startAt
										image {
											id
											url
											urlThumb
										}
										status
										statusClass
										statusText
									}
								}
								pageInfo {
									totalItems
								}
							}
						}
					`,
					variables: {
						take: this.pagination.length,
						skip: this.pagination.skip
					},
					fetchPolicy: "network-only"
				})
				.then(({ data }) => {
					this.eventsPromoted = data.eventsPromoted.data
					// this.pagination.pageInfo = data.events.pageInfo
					this.loading = false
				})
		}
	}
}
</script>

<style scoped lang="scss">
.table {
	.image {
		width: 32px;
		height: 32px;
		background-color: #f3f3f3;
		border-radius: 8px;
		margin-right: 2px;
		// margin: -8px 0px;
		background-size: cover;
		background-position: center;
		background-repeat: no-repeat;
	}
}
</style>
